import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { ICreateAccountStore } from '../interfaces/create-account-store.interface';

export const selectCreateAccountStore = (state: IAppState) =>
  state.createAccount;

export const selectTellUsProperties = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => ({
    registeredCompanyName: createAccountStore.registeredCompanyName,
    firstName: createAccountStore.firstName,
    lastName: createAccountStore.lastName,
    email: createAccountStore.email,
    heardAboutUsId: createAccountStore.heardAboutUsId,
    howDidYouHearAboutUs: createAccountStore.howDidYouHearAboutUs,
    heardAboutUsDetails: createAccountStore.heardAboutUsDetails,
  })
);

export const selectFirstAndLastName = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => ({
    firstName: createAccountStore.firstName,
    lastName: createAccountStore.lastName,
  })
);

export const selectPhoneNumbers = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => ({
    mobilePhoneNumber: createAccountStore.mobilePhoneNumber,
    businessPhoneNumber: createAccountStore.businessPhoneNumber,
  })
);

export const selectRegisteredCompanyName = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) =>
    createAccountStore.registeredCompanyName
);

export const selectFirstName = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.firstName
);

export const selectLastName = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.lastName
);

export const selectEmail = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.email
);

export const selectCode = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.code
);

export const selectClientNumber = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.clientNumber
);

export const selectHeardAboutUsId = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => createAccountStore.heardAboutUsId
);

export const selectHeardAboutUsDetails = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) =>
    createAccountStore.heardAboutUsDetails
);

export const selectMobilePhoneNumber = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) =>
    createAccountStore.mobilePhoneNumber
);

export const selectBusinessPhoneNumber = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) =>
    createAccountStore.businessPhoneNumber
);

export const selectAllCreateAccount = createSelector(
  selectCreateAccountStore,
  (createAccountStore: ICreateAccountStore) => ({
    registeredCompanyName: createAccountStore.registeredCompanyName,
    firstName: createAccountStore.firstName,
    lastName: createAccountStore.lastName,
    email: createAccountStore.email,
    code: createAccountStore.code,
    heardAboutUsId: createAccountStore.heardAboutUsId,
    howDidYouHearAboutUs: createAccountStore.howDidYouHearAboutUs,
    heardAboutUsDetails: createAccountStore.heardAboutUsDetails,
    mobilePhoneNumber: createAccountStore.mobilePhoneNumber,
    businessPhoneNumber: createAccountStore.businessPhoneNumber,
  })
);
